import cityData from './cityData.json';

// Create a map of state to its cities
export const stateToCities = Object.entries(cityData.states).reduce((acc, [state, data]) => {
  acc[state] = Object.keys(data.cities);
  return acc;
}, {});

// Create a map of city to its state
export const cityToState = Object.entries(cityData.states).reduce((acc, [state, data]) => {
  Object.keys(data.cities).forEach(city => {
    acc[city] = state;
  });
  return acc;
}, {});

// Create a map of city to its climate zone
export const cityToClimateZone = Object.values(cityData.states).reduce((acc, state) => {
  Object.entries(state.cities).forEach(([city, data]) => {
    acc[city] = data.climateZone;
  });
  return acc;
}, {});

// Get all states in alphabetical order
export const getAllStates = () => {
  return Object.keys(stateToCities).sort();
};

// Get cities for a specific state in alphabetical order
export const getCitiesForState = (state) => {
  return stateToCities[state] ? [...stateToCities[state]].sort() : [];
};

// Get climate zone for a specific city
export const getClimateZone = (city) => {
  return cityToClimateZone[city] || '';
};

// Get state for a specific city
export const getStateForCity = (city) => {
  return cityToState[city] || '';
};

// Validate if a city belongs to a state
export const isCityInState = (city, state) => {
  return stateToCities[state]?.includes(city) || false;
}; 